import React from "react";
import { dateToString, thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

const MyWithdrawInfo = ({ portfolio }) => {
	const { t } = useTranslation();

	return (
		<li>
			<div className="title-group">
				<h3 className="basic-info-title">
					{t("pages.portfolio.PortfolioView.components.MyWithdrawInfo.historyWithdraw")}(
					{portfolio?.VcWithdraw?.length || 0})
				</h3>
				<span>
					{t("pages.portfolio.PortfolioView.components.MyWithdrawInfo.totalWithdraw")}:
					{thousandFormatter(
						portfolio?.VcWithdraw?.reduce(
							(prev, withdraw) => prev + Number(withdraw.value, 10),
							0
						)
					) || 0}
					{t("pages.portfolio.PortfolioView.components.MyInvestInfo.hMillion")}
				</span>
			</div>
			<div className="timeline-wrap">
				<ol>
					{portfolio?.VcWithdraw?.map((withdraw) => {
						return (
							<li key={withdraw.idx} className="timeline-item">
								<span className="timeline-date">
									{dateToString(withdraw.withdrawDate, "yyyy-MM-dd")}
								</span>
								<ul className="timeline-content">
									<li>
										<ul className="vc-invest-history">
											<li>
												{t(
													"pages.portfolio.PortfolioView.components.MyWithdrawInfo.withdrawAmount"
												)}{" "}
												:{" "}
												<span>
													{withdraw.value !== ""
														? thousandFormatter(withdraw.value)
														: 0}
													{t(
														"pages.portfolio.PortfolioView.components.MyWithdrawInfo.hMillion"
													)}
												</span>
											</li>
										</ul>
									</li>
								</ul>
							</li>
						);
					})}
				</ol>
			</div>
		</li>
	);
};

export default MyWithdrawInfo;
